import React from "react";
import { Link } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";

export default () => {
  return (
    <Grid>
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          <h4>About</h4>
          <p>
            IBorrow Desk is a tool for monitoring borrow rates and availability
            using Interactive Broker's freely available data.
          </p>
          <p>
            I worked in finance for the past five years, with my last year or so
            doing a decent amount of short selling. One of the resources I used
            quite a lot was Interactive Broker's{" "}
            <a href="https://ibkb.interactivebrokers.com/article/2024">
              Stock Loan Availability Database
            </a>{" "}
            especially for hard to borrow stocks.
          </p>
          <p>
            But it was a pain to keep updated and an overall a pain to use. So,
            after taking Udacity's{" "}
            <a href="https://www.udacity.com/course/full-stack-web-developer-nanodegree--nd004">
              Full Stack Nanodegree
            </a>{" "}
            I figured this database would be a fun place to start building a
            working (maybe even useful) web app.
          </p>
          <p>
            Built in Python, I used the Flask framework and SQLAlchemy for the
            user database and PostgreSQL for the borrow database. Memcached
            caches historical reports for those pesky Twitter bots.
          </p>
          <p>
            {" "}
            The front-end was rebuilt entirely in the beginning of 2016 using{" "}
            <a href="https://facebook.github.io/react/">React</a>.
          </p>
          <p>You can reach me at cameron.mochrie@gmail.com.</p>

          <h4>FAQ</h4>
          <p>
            <strong>Who are you?</strong> I worked in finance in Toronto until
            2015 when I taught myself to code. IBorrowDesk was my first
            'product' and I've been maintaining, and improving it since then.
            Since 2017 I've worked as a software developer for{" "}
            <a href="https:///www.wealthsimple.com" target="_blank">
              Wealthsimple
            </a>
            .
          </p>

          <p>
            <strong>What exactly does this thing do?</strong> Downloads a series
            of csv files from the Interactive Broker's FTP site, chucks
            everything into a postgreSQL database and displays it on your
            screen.
          </p>

          <p>
            <strong>What are the benefits of registering?</strong> Registered
            users can create a watchlist of symbols (similar format to the front
            page) to track stocks they are interested in. You can also create
            alerts - triggers that fire when a security reaches a certain
            threshold of fee rate or overall availability.
          </p>

          <p>
            <strong>What are the benefits of becoming a Patron?</strong>All
            Patrons can enjoy an advertising free experience. Patrons at the $1+
            level gain additional alert slots (can track 10 securities). Patrons
            at the $10 level can access over 5 years of data (otherwise limited
            to 1 year), export historical data via CSV, and can track up to 50
            securities with alerts.
          </p>

          <p>
            <strong>What is the ticker structure?</strong> I'm currently
            tracking Interactive Broker's worldwide database which includes:
            Australia, Austria, Belgium, UK, Canada, Netherlands, France,
            Germany, Hong Kong, India, Italy, Japan, Mexico, Spain, Sweden,
            Switzerland, and the USA. US tickers do not have a suffix, while all
            other countries do (in the form:{" "}
            <Link to="report/ABX.CA">ABX.CA</Link>- Barrick Gold) I have tried
            to match country codes based on{" "}
            <a href="http://risk101.com/reference/Techdoc-Bloomberg_country_codes.pdf">
              Bloomberg's
            </a>{" "}
            methodology. Let me know if you spot any errors.
          </p>

          <p>
            <strong>How often is the database updated?</strong> Every 15 minutes
            (every hour outside North America) around trading hours on weekdays
            (so almost 24 hours a day given the global scope within a minute of
            IB refreshing on their end.
          </p>

          <p>
            <strong>How far back does the data go?</strong> Historical data (one
            row/day) will be retained indefinitely and accessible to $10+
            supporters, while 'real-time' data is retained for one week.
          </p>
        </Col>
      </Row>
    </Grid>
  );
};
